export default "__VITE_ASSET__DBcCJyUP__"